import { NgxBootstrapModule } from "src/app/modules/shared/ngx-bootstrap/ngx-bootstrap.module";
import { NgxUtilitiesModule } from "./../../ngx-utilities/ngx-utilities.module";
import { SharedModule } from "src/app/shared/shared.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MediaManagerRoutingModule } from "./media-manager-routing.module";
// import { MediaManagerService } from "src/app/media/media-manager.service";
import { MediaDialogComponent } from "src/app/new-media/new-media-manager/media-dialog/media-dialog.component";
import { SubFoldersComponent } from "src/app/new-media/new-media-manager/folders/sub-folders/sub-folders.component";
import { MediaFoldersComponent } from "src/app/new-media/new-media-manager/media-folders/media-folders.component";
import { AddEditFolderComponent } from "src/app/new-media/new-media-manager/folders/add-edit-folder/add-edit-folder.component";
import { FoldersComponent } from "src/app/new-media/new-media-manager/folders/folders.component";
import { ListComponent } from "src/app/new-media/new-media-manager/list/list.component";
import { ManageMediaComponent } from "src/app/new-media/new-media-manager/media-folders/manage-media/manage-media.component";
import { DetailsComponent } from "src/app/new-media/new-media-manager/media-folders/manage-media/details/details.component";
import { MetaComponent } from "src/app/new-media/new-media-manager/media-folders/manage-media/meta/meta.component";
import { PreviewComponent } from "src/app/new-media/new-media-manager/media-folders/manage-media/preview/preview.component";
import { UpdateComponent } from "src/app/new-media/new-media-manager/media-folders/manage-media/update/update.component";
import { MaterialUtilitiesModule } from "../../material-utilities/material-utilities.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AngularCropperjsModule } from 'angular-cropperjs';
import { DragDropModule } from '@angular/cdk/drag-drop';
@NgModule({
  declarations: [
    MediaDialogComponent,
    MediaFoldersComponent,
    AddEditFolderComponent,
    ManageMediaComponent,
    PreviewComponent,
    DetailsComponent,
    MetaComponent,
    UpdateComponent,
    SubFoldersComponent,
  ],
  imports: [
    CommonModule,
    MediaManagerRoutingModule,
    NgxBootstrapModule,
    NgxUtilitiesModule,
    SharedModule,
    AngularCropperjsModule,
     DragDropModule,

    NgxBootstrapModule,
    NgxUtilitiesModule,
    MaterialUtilitiesModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    MediaDialogComponent,
    AddEditFolderComponent,
    ManageMediaComponent,
    MediaFoldersComponent,
    PreviewComponent,
    DetailsComponent,
    MetaComponent,
    UpdateComponent,
    SubFoldersComponent,
  ],
  // entryComponents: [
  //   MediaDialogComponent,
  //   AddEditFolderComponent,
  //   ManageMediaComponent,
  //   SubFoldersComponent,
  // ],
})
export class MediaManagerModule {}
